import Image, { getImageProps } from 'next/image'
import { Item } from 'react-photoswipe-gallery'
import { getMediaUrl } from 'src/_helpers/client/getMediaUrl'
import Typography from 'src/components/design-system/Typography'

const GalleryItem = ({ title, alt, thumb, photo, captionVariant = 'default', ariaLabel }) => {
  if (!thumb || !photo) return null

  const width = thumb.width || photo.width || 800
  const height = thumb.height || photo.height || 600

  const { props: thumbnail } = getImageProps({
    alt: alt,
    width,
    height,
    src: getMediaUrl(thumb.url, thumb.version),
  })
  const { props: original } = getImageProps({
    alt: alt,
    width: photo.width || width,
    height: photo.height || height,
    src: getMediaUrl(photo?.url),
  })

  const caption =
    captionVariant === 'dot' ? (
      <div className="flex items-center gap-x-10">
        <span className="bg-style1 w-11 h-11 rounded-full"></span>
        <Typography variant="body3" component="figcaption" color="text-dark-blue-dark-blue1">
          {alt}
        </Typography>
      </div>
    ) : (
      <Typography variant="body3" component="figcaption" color="text-dark-blue-dark-blue1">
        {alt}
      </Typography>
    )

  return (
    <Item
      original={original.src}
      thumbnail={thumbnail.src}
      width={original.width}
      height={original.height}
      caption={title}
    >
      {({ ref, open }) => (
        <a
          href={original.src}
          className="group relative block"
          ref={ref}
          onClick={(e) => {
            e.preventDefault()
            open(e)
          }}
          aria-label={ariaLabel || title || alt || 'Open image'}
        >
          <figure className="flex flex-col gap-8">
            <Image {...thumbnail} alt={thumbnail.alt || ' '} className="w-full object-cover object-center h-full" />
            {caption}
          </figure>
        </a>
      )}
    </Item>
  )
}

export { GalleryItem }
